import React from 'react';
import Button from './Button';
import Icon from '../AppIcon';

const QuickActionToolbar = ({ className = "" }) => {
  const quickActions = [
    {
      label: 'View Surveys',
      icon: 'ClipboardList',
      variant: 'default',
      path: '/surveys',
      description: 'View and manage surveys'
    },
    {
      label: 'Add Property',
      icon: 'Building',
      variant: 'outline',
      path: '/property-management',
      description: 'Add property to portfolio'
    },
    {
      label: 'New Client',
      icon: 'UserPlus',
      variant: 'outline',
      path: '/client-management',
      description: 'Register new client'
    },
    {
      label: 'View Reports',
      icon: 'FileText',
      variant: 'ghost',
      path: '/reports-analytics',
      description: 'Access reports and analytics'
    }
  ];

  const handleQuickAction = (path) => {
    window.location.href = path;
  };

  return (
    <div className={`bg-card rounded-lg border border-border p-6 ${className}`}>
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Zap" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
      </div>
      {/* Desktop Layout */}
      <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {quickActions?.map((action) => (
          <Button
            key={action?.path}
            variant={action?.variant}
            onClick={() => handleQuickAction(action?.path)}
            className="h-auto p-4 flex flex-col items-center space-y-2 text-center"
            title={action?.description}
          >
            <Icon name={action?.icon} size={24} />
            <span className="text-sm font-medium">{action?.label}</span>
          </Button>
        ))}
      </div>
      {/* Mobile Layout */}
      <div className="sm:hidden space-y-2">
        {quickActions?.map((action) => (
          <Button
            key={action?.path}
            variant={action?.variant}
            onClick={() => handleQuickAction(action?.path)}
            className="w-full justify-start"
            iconName={action?.icon}
            iconPosition="left"
            title={action?.description}
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionToolbar;